/**
 * Chart colors for the Allo inline charts (SD-2674) — the single source of
 * truth. chart.js paints onto a canvas, so CSS custom properties can't style
 * these.
 */
export interface ChartPalette {
  /** One color per category; indexes past the end wrap around. */
  categorical: string[];
  /** Two-tone pairing for period-over-period comparisons. */
  duo: string[];
  grid: string;
  text: string;
}

export const CHART_PALETTE: ChartPalette = {
  categorical: [
    '#1c2a3a',
    '#f9423a',
    '#3f8f6b',
    '#4f7fd0',
    '#d9a13a',
    '#7c5cc4',
    '#5b6166',
    '#a7a392',
    '#2c4a52',
    '#c0563f',
  ],
  duo: ['#1c2a3a', '#f9423a'],
  grid: '#e8e5de',
  text: '#1f2937',
};
